import { css } from '@emotion/core';
import { Heading3, StackView, Text } from 'localmed-core';
import React, { useContext, useEffect } from 'react';
import { UniversalContext } from '../../../../_universal';
import DIError from '../../../icons/DI/DIError';
import DiModal from './DiModal';

interface IProps {
  open: boolean;
  closeModal: () => void;
  text: string;
  error?: Error;
}

export default function DiErrorModal({ open, closeModal, text, error }: IProps) {
  const { trackError } = useContext(UniversalContext);

  useEffect(() => {
    trackError({
      error: error || text || 'An Error Occured',
      properties: { component: 'DiErrorModal' },
    });
  }, [error, text, trackError]);

  return (
    <DiModal
      role="dialog"
      isOpen={open}
      onRequestClose={closeModal}
      size="xs"
      verticalAlign="top"
      closeBtnText="Retry"
    >
      <StackView spacing="sm">
        <DIError
          css={css`
            height: 5em;
          `}
        />
        <Heading3>Oops!</Heading3>
        <Text className="mb-4">{text}</Text>
      </StackView>
    </DiModal>
  );
}
